import styled from 'styled-components';

import { Box } from 'components/Box';
import { colors, mediaRetina, transition } from 'theme/theme';

export const DropBox = styled(Box)<{
  $overlayButton?: boolean;
  $hasImage?: boolean;
}>`
  color: ${(props) =>
    props.$overlayButton && props.$hasImage ? 'white' : colors.brandBlue};
  transition: all ${transition};

  & > * {
    position: relative;
    border: 1px dashed ${colors.elementGrey};
    border-radius: 8px;
    transition: border ${transition};
    ${mediaRetina} {
      border-width: 1.5px;
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: ${(props) => (props.$overlayButton ? 0 : 8)}px;
    opacity: 0;
    background: ${(props) =>
      props.$overlayButton && props.$hasImage
        ? 'rgba(0,0,0,0.5)'
        : 'transparent'};
    transition: all ${transition};
  }
`;
